export default [{
    path: '/brand/index',
    name: '品牌首页',
    component: function (resolve) {
      require(['@/pages/brand/index'], resolve)
    }
  },
  {
    path: '/brand/detail',
    name: '品牌详情',
    component: function (resolve) {
      require(['@/pages/brand/detail'], resolve)
    }
  },
  {
    path: '/brand/space/detail',
    name: '场地详情',
    component: function (resolve) {
      require(['@/pages/brand/spaceDetail'], resolve)
    }
  },
  {
    path: '/brand/auth',
    name: '授权品牌',
    component: function (resolve) {
      require(['@/pages/brand/authorize'], resolve)
    }
  },
  {
    path: '/brand/invite',
    name: '邀请产品',
    component: function (resolve) {
      require(['@/pages/brand/invite-brand'], resolve)
    }
  },
  {
    path: '/brand/invite/detail',
    name: '邀请产品详情',
    component: function (resolve) {
      require(['@/pages/brand/invite-brand-detail'], resolve)
    }
  },
  {
    path: '/brand/industrial',
    name: '产业链',
    component: function (resolve) {
      require(['@/pages/brand/industrial-chain'], resolve)
    }
  },
  {
    path: '/complaintFeedback/detail',
    name: '投诉详情',
    component: function (resolve) {
      require(['@/pages/complaintFeedback/detail'], resolve)
    }
  },
  {
    path: '/complaintFeedback/brand/detail',
    name: '品牌-投诉详情',
    component: function (resolve) {
      require(['@/pages/complaintFeedback/brandComplain'], resolve)
    }
  },
  {
    path: '/dev/camera/list',
    name: '品牌-投诉详情',
    component: function (resolve) {
      require(['@/pages/dev/camera-list'], resolve)
    }
  },
  {
    path: '/looking/back',
    name: '品牌-投诉详情',
    component: function (resolve) {
      require(['@/pages/dev/looking-back'], resolve)
    }
  },
  {
    path: '/dev/inspection',
    name: '品牌-投诉详情',
    component: function (resolve) {
      require(['@/pages/dev/inspection'], resolve)
    }
  },
]



// WEBPACK FOOTER //
// ./src/router/govLayout/brand.js